export default __webpack_public_path__ + "static/media/IDS_Hero.585b895d.png";